export const logoutUrl = (idToken) => {
  const redirectUri = `${window.location.protocol}//${window.location.host}`;
  const params = new URLSearchParams({
    post_logout_redirect_uri: redirectUri,
  });
  
  // Include id_token_hint to skip logout confirmation page
  if (idToken) {
    params.append('id_token_hint', idToken);
  }
  
  return `${process.env.KEYCLOAK_LOGOUT_URL}?${params.toString()}`;
};
